import { faPause, faPlay } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import ReactPlayer from 'react-player';

export function SimplePlayer({
  src,
  poster,
  className,
}: {
  src: string;
  poster?: string;
  className?: string;
}) {
  const videoRef = React.useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const togglePlay = (shouldPlay?: boolean) => {
    if (videoRef.current) {
      const turnOn =
        shouldPlay !== undefined ? shouldPlay : videoRef.current.paused;

      if (turnOn) {
        videoRef.current.play();
        setIsPlaying(true);
      } else {
        videoRef.current.pause();
        setIsPlaying(false);
      }
    }
  };
  useEffect(
    function rewindOnEnd() {
      if (videoRef.current) {
        videoRef.current.addEventListener('ended', () => {
          if (!videoRef.current) return;

          videoRef.current.currentTime = 0;
          togglePlay(false);
        });
      }
    },
    [videoRef],
  );
  useEffect(function disableControls() {
    if (videoRef.current) {
      videoRef.current.controls = false;
    }
  });

  return (
    <div
      className={classNames(className, 'relative !bg-black')}
      onClick={() => togglePlay()}
    >
      <video
        ref={videoRef}
        src={src}
        poster={poster}
        className="rounded-md"
        preload="none"
        playsInline
      />
      {!isPlaying ? (
        <button className="absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] rounded-full bg-gray-400 bg-opacity-50 w-[40px] h-[40px]">
          <FontAwesomeIcon icon={isPlaying ? faPause : faPlay} color="white" />
        </button>
      ) : null}
    </div>
  );
}

export function SimplePlayer2({
  // NOTE: with support for steams but needs more works with CSS
  src,
  poster,
}: {
  src: string;
  poster?: string;
}) {
  const [isPlaying, setIsPlaying] = useState(false);
  return (
    <div className="relative">
      <ReactPlayer
        playing={isPlaying}
        playsinline
        url={src}
        config={{ file: { attributes: { poster, preload: 'auto' } } }}
        onEnded={() => setIsPlaying(false)}
        style={{
          borderRadius: '6px',
          overflow: 'hidden',
        }}
      />
      {!isPlaying ? (
        <button className="absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] rounded-full bg-gray-400 bg-opacity-50 w-[40px] h-[40px]">
          <FontAwesomeIcon icon={isPlaying ? faPause : faPlay} color="white" />
        </button>
      ) : null}
    </div>
  );
}
